import { Outlet, Navigate, useLocation } from 'react-router';
import { Loader } from '@f2m3/shared-frontend-ui';
import { useAccountInfo } from '../../api/queryHooks/account';
import { useLogin } from '../../hooks/useLogin';
import { useAlbumWall } from '../../hooks/useAlbumWall';

/**
 * Route guard for a shop that requires registration to view albums: a guest
 * (someone who only opened an album by code) is sent to login. The guest
 * session is deliberately kept (unlike GuestCheckoutGuard) so a further code
 * entered on the login page attaches to the same guest.
 *
 * A signed-in customer who has not confirmed their email goes to the code page
 * instead (useVerificationWall decides who that is).
 *
 * A shop switched to "registered" while the guest browses is noticed through
 * the 403 fallback in utils/queryClient.ts, which refetches accountInfo.
 */
const AlbumWallGuard = () => {
  const { isGuest } = useLogin();
  const { isPending } = useAccountInfo();
  const { walled, verificationRequired, ready } = useAlbumWall();
  const location = useLocation();

  if ((isGuest && isPending) || !ready) return <Loader />;

  const from = location.pathname + location.search;

  if (walled) {
    return <Navigate to="/login" replace state={{ from, registrationRequired: true }} />;
  }

  if (verificationRequired) {
    return <Navigate to="/verify-email/code" replace state={{ from }} />;
  }

  return <Outlet />;
};

export default AlbumWallGuard;
